const t=t=>t.reduce(((t,e)=>(t[e.attribute]=e,t)),{});export{t as getCurrentRefinementsByAttributeMap};
